import createPersonaSearchQueryString from '../helpers/createPersonaSearchQueryString';
import { OR_SEPARATOR, SPACE } from '../searchConstants';
import { getScenarioStore, SearchScenarioId } from 'owa-search';
import { SuggestionKind } from 'owa-search-service';

export default function getSearchQueryString() {
    const searchStore = getScenarioStore(SearchScenarioId.Calendar);

    // Create query strings for suggestion pills.
    const queryStringsForSuggestionPills: string[] = [];
    if (searchStore.suggestionPillIds) {
        for (let i = 0; i < searchStore.suggestionPillIds.length; i++) {
            const suggestion = searchStore.suggestionPills.get(searchStore.suggestionPillIds[i]);
            if (suggestion.kind == SuggestionKind.People) {
                queryStringsForSuggestionPills.push(createPersonaSearchQueryString(suggestion));
            }
        }
    }

    // Join pill queries into a single query (OR'ed).
    let combinedQueryStringForSearchPills = '';
    if (queryStringsForSuggestionPills.length > 0) {
        combinedQueryStringForSearchPills = queryStringsForSuggestionPills.join(OR_SEPARATOR);
    }

    // Join pills query string with the search keyword query string.
    const queryString = [combinedQueryStringForSearchPills, searchStore.searchText]
        // Remove extra whitespace from parts.
        .map((query: string) => query && query.trim())
        // Remove any null or empty parts.
        .filter((query: string) => query.length > 0)
        // Concatenate parts with spaces in between.
        .join(SPACE);

    // Return KQL.
    return queryString;
}
